import { render, staticRenderFns } from "./radioMatckMaking.vue?vue&type=template&id=051cdb08&scoped=true"
import script from "./radioMatckMaking.vue?vue&type=script&lang=js"
export * from "./radioMatckMaking.vue?vue&type=script&lang=js"
import style0 from "./radioMatckMaking.vue?vue&type=style&index=0&id=051cdb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051cdb08",
  null
  
)

export default component.exports